import { createSlice, createAction } from "@reduxjs/toolkit"

import ProfileGroupNormalizer from '../normalizers/profile_group';

export const profileGroupFetchStarted = createAction('ProfileGroup/fetchStarted');
export const profileGroupFetchFailed = createAction('ProfileGroup/fetchFailed');

const profileGroupSlice = createSlice({
  name: 'profileGroup',
  initialState: { current: null, entities: { ProfileGroup: {}, profiles: [] }, result: [] },
  reducers: {
    saveProfileGroup: (state, action) => { 
      console.log(action);
      return ProfileGroupNormalizer.normalize(action.payload);
    }
  }
})

// Extract the action creators object and the reducer
const { actions, reducer } = profileGroupSlice
// Extract and export each action creator by name
export const { saveProfileGroup } = actions
// Export the reducer, either as a default or named export
export default reducer